/* -------------------------------------------------------------------------- */
/*                                Schema Reports                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const report = new schema.Entity('reports', {}, { idAttribute: 'reportId' });
export const reports = new schema.Array(report);
